import { Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    './components/smart/package-list-page/package-list-page.component'
  ).then((m) => m.PackageListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/homepage-builder-package-detail-page/homepage-builder-package-detail-page.component'
  ).then((m) => m.HomepageBuilderPackageDetailPageComponent);

export const homepageBuilderPackageRoutes: Routes = [
  {
    path: 'homepage-master/package/homepage-builder-package',
    data: { title: 'Homepage Package' },
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: { title: 'Homepage Package Detail' },
          },
        ],
      },
    ],
  },
];
